// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router';
import ProjectMapList from './ProjectMapList';

const ProjectMapListContainer = withRouter<any, any>(ProjectMapList);

export default ProjectMapListContainer;
